import { HomeExtendedInfo } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartStore'

export interface ExtendedColumnConfigProps {
  header: JSX.Element
  columnKey: string
  groupId?: string
  width: number
  renderer: (home?: HomeExtendedInfo) => JSX.Element
}

export interface ExtendedColumnHeaderProps extends ExtendedColumnConfigProps {
  groundHeaders?: JSX.Element[]
  groupLabel?: JSX.Element
}

export enum ExtendedColumnGroups {
  arrivalsChecklist = 'arrivalsChecklist',
}
